import { Spinner } from '@cian/ui-kit';
import { mergeStyles } from '@cian/utils';
import React, { forwardRef } from 'react';
import * as styles from './FiltersSearchButton.css';

export interface IFiltersSearchButtonProps {
  href: string;
  title?: string;
  text: string;
  dataMark: string;
  isLoading?: boolean;
  isLight?: boolean;
  isExternal?: boolean;
  onClick?(e: React.SyntheticEvent<HTMLElement>): void;
}

export const FiltersSearchButton = forwardRef<HTMLElement, IFiltersSearchButtonProps>(
  ({ href, text, title, dataMark, isLight, isLoading, isExternal, onClick, ...props }, ref) => {
    const loaderColor = isLight ? 'primary_100' : 'white_100';

    return (
      <span {...props} className={styles['container']} ref={ref}>
        {/* eslint-disable-next-line react/jsx-no-target-blank */}
        <a
          {...mergeStyles(styles['button'], isLoading && styles['button--loading'], isLight && styles['button--light'])}
          href={href}
          title={title}
          data-mark={dataMark}
          data-name={dataMark}
          onClick={onClick}
          rel={isExternal ? 'nofollow noreferrer' : undefined}
          target={isExternal ? '_blank' : '_self'}
        >
          {text}
          {isLoading && (
            <span className={styles['preloader']}>
              <Spinner size={18} color={loaderColor} />
            </span>
          )}
        </a>
      </span>
    );
  },
);

FiltersSearchButton.displayName = 'FiltersSearchButton';
